import Symbol           from 'es6-symbol/polyfill';
import EventEmitter     from 'events';
import axios            from 'axios';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class ProductsService extends EventEmitter {

  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new ProductsService(singletonEnforcer);
    }
    return this[singleton];
  }

  getAll(params = {}) {
    const seq = axios.get('/api/v2/products', {params});
    seq.catch( console.error );
    return seq;
  }

}
export default ProductsService.getInstance();